module.exports = __webpack_public_path__ + "img/1.2.e0c2a8eb.png";